import React, { useState, useEffect } from "react"; // <----  Импорт useEffect добавим
import PropTypes from "prop-types";

function EditPermanentInvitationListModal({ isOpen, onClose, onUpdate, listData }) { // <---- Заменили onSave на onUpdate и добавили listData prop
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");

  // Используем useEffect, чтобы установить значения полей при открытии модалки
  useEffect(() => {
    if (listData) {
      setName(listData.name || ""); // Устанавливаем имя из listData, если есть
      setDescription(listData.description || ""); // Устанавливаем описание из listData, если есть
    } else {
      setName(""); // Очищаем имя, если listData нет (на всякий случай)
      setDescription(""); // Очищаем описание, если listData нет (на всякий случай)
    }
  }, [listData, isOpen]); // Зависимость от listData и isOpen, чтобы обновлять значения при изменении listData и открытии модалки

  const handleSave = async () => {
    console.log("EditPermanentInvitationListModal - handleSave - Start");
    if (!name.trim()) {
      alert("Please enter a list name.");
      return;
    }

    // Создаем объект с данными списка, включая ID редактируемого списка
    const updatedListData = {
      id: listData.id, // <---- ВАЖНО: Добавляем ID редактируемого списка из props
      name: name,
      description: description,
    };

    try {
      // TODO: Отправить PUT запрос на бэкенд для обновления списка перманентных приглашений
      // Пример: await fetch(`/api/permanent-invitations/lists/${listData.id}`, ...)
      console.log("EditPermanentInvitationListModal - handleSave - Updating permanent invitation list:", updatedListData); // Лог с обновленными данными

      // После успешного обновления списка, вызвать onUpdate и закрыть модалку
      if (onUpdate) {
        console.log("EditPermanentInvitationListModal - handleSave - Calling onUpdate with data:", updatedListData);
        await onUpdate(updatedListData); // <---- Вызываем onUpdate, а не onSave
        console.log("EditPermanentInvitationListModal - handleSave - onUpdate completed");
      }
      onClose();
    } catch (error) {
      console.error("EditPermanentInvitationListModal - handleSave - Error updating permanent invitation list:", error);
      alert("Failed to update permanent invitation list.");
    } finally {
      console.log("EditPermanentInvitationListModal - handleSave - End");
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-[500px] relative">
        <h2 className="text-xl font-bold mb-4">Edit Invitation List</h2> {/* <---- Изменили заголовок модалки */}

        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">
            List Name
          </label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="mt-1 block w-full border-gray-300 rounded-md shadow-sm"
            placeholder="Enter list name"
          />
        </div>

        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700">
            Description (optional)
          </label>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            rows={3}
            className="mt-1 block w-full border-gray-300 rounded-md shadow-sm"
            placeholder="Enter description"
          />
        </div>

        <div className="flex justify-end space-x-2 mt-4">
          <button
            onClick={handleSave}
            className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 transition"
          >
            Update {/* <---- Изменили текст кнопки на "Update" */}
          </button>
          <button
            onClick={onClose}
            className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600 transition"
          >
            Cancel
          </button>
        </div>

        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 text-2xl"
        >
          ×
        </button>
      </div>
    </div>
  );
}

EditPermanentInvitationListModal.propTypes = { // <----  propTypes для EditModal
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired, // <---- Заменили onSave на onUpdate
  listData: PropTypes.shape({ // <---- Добавили propType для listData
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.string,
  }),
};

export default EditPermanentInvitationListModal;